function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 17780",
  transform: "translate(-618.985 -1236)",
  opacity: 0.53
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 19968",
  width: 512.277,
  height: 351.071,
  rx: 6,
  transform: "translate(618.985 1236.224)",
  fill: "#eae9ef",
  opacity: 0.062
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356830",
  d: "M1185.388 1528.067l-104.633-.187a.705.705 0 110-1.41l104.633.187a.705.705 0 110 1.41z",
  fill: "#eae9ef"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5990",
  cx: 9.873,
  cy: 9.873,
  transform: "translate(1177.078 1518.191)",
  fill: "#eae9ef",
  r: 9.873
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 16668"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356831",
  d: "M1043.664 1360.882a31.139 31.139 0 10-31.142-31.139 31.139 31.139 0 0031.142 31.139zm0-60.13a28.991 28.991 0 11-28.992 28.991 28.991 28.991 0 0128.992-28.992z",
  fill: "#eae9ef"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 16617"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356851",
  d: "M1030.022 1333.494c.291 17.065 25.675 17.063 25.964 0-.291-17.065-25.675-17.062-25.964 0z",
  fill: "#513ea5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356852",
  d: "M1043.517 1338.791l.013-.485c-3.344.447-4.064-3.7-.692-2.148l-.77-5.625-.481.066.655 4.785c-3.546-.529-2.233 3.892 1.275 3.407z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 19783",
  fill: "#fff",
  d: "M1036.601 1331.012h2.613v.485h-2.613z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 19784",
  fill: "#fff",
  d: "M1044.849 1331.012h2.613v.485h-2.613z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 158",
  d: "M1053.961 1357.387a13.207 13.207 0 00-1.06-1.5 12.919 12.919 0 00-6.21-4.242 2.309 2.309 0 00-2.251-2.79c-.314 0-.67-.006-1.046-.016-2.173-.061-5.033-.122-4.6 2.808a12.781 12.781 0 00-5.909 3.881 13.421 13.421 0 00-1.356 1.858h.275a94.162 94.162 0 0011.006 2.409 11.394 11.394 0 001.56.1 24.78 24.78 0 009.591-2.508z",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356854",
  d: "M1049.108 1327.355c-2.406-1.39-5.323-.324-7.809.259-4.715 1.449-11.327-.366-11.9-5.982-.6-5.224 6.549-8.135 8.833-2.936l-.665-.087c7.407-11.008 20.292-10.591 20.207 4.544.028.468-.7.466-.727 0 .273-8.919-5.63-15.015-13.973-9.284a24.581 24.581 0 00-4.878 5.108c-.869.974-1.058-3.22-5.217-2.122-4.577 1.773-3.083 8.327 1.008 9.766 5.055 2.582 10.529-2.425 15.489.105a.364.364 0 01-.367.629z",
  fill: "#2f2e41"
}))), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357005",
  d: "M1126.44 1236H627.251a7.178 7.178 0 00-7.171 7.171v338.263a7.178 7.178 0 007.171 7.171h499.19a7.165 7.165 0 005.452-2.516 1.681 1.681 0 00.156-.2 6.717 6.717 0 001.028-1.735 7 7 0 00.542-2.722v-210.568h-2.047v210.57a5.082 5.082 0 01-.847 2.813 5.309 5.309 0 01-1.941 1.743 5.085 5.085 0 01-2.344.568H627.251a5.13 5.13 0 01-5.124-5.124v-338.263a5.13 5.13 0 015.124-5.124h499.19a5.131 5.131 0 015.132 5.124v45.453h2.047v-45.453a7.179 7.179 0 00-7.18-7.171z",
  fill: "#eae9ef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 19805",
  fill: "#eae9ef",
  d: "M621.1 1264.743h511.49v2.05H621.1z"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6010",
  cx: 6.15,
  cy: 6.15,
  r: 6.15,
  transform: "translate(632.375 1245.227)",
  fill: "#eff5f5"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6011",
  cx: 6.15,
  cy: 6.15,
  r: 6.15,
  transform: "translate(650.056 1245.227)",
  fill: "#eff5f5"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6012",
  cx: 6.15,
  cy: 6.15,
  r: 6.15,
  transform: "translate(667.739 1245.227)",
  fill: "#eff5f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357006",
  d: "M797.42 1547.144a12.73 12.73 0 01-11.568-17.913l14.651-32.694a109.609 109.609 0 1141.438 23.079l-37.392 25.321a12.69 12.69 0 01-7.129 2.207zm75.607-226.02a93.868 93.868 0 00-58.477 167.339l4.616 3.681-15.763 35.176 36.178-24.492 3.572 1.2a93.9 93.9 0 1029.876-182.9z",
  fill: "#e7f1f1",
  opacity: 0.705
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6013",
  cx: 15.231,
  cy: 15.231,
  r: 15.231,
  transform: "translate(857.797 1394.738)",
  fill: "#e7f1f1",
  opacity: 0.631
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6014",
  cx: 15.231,
  cy: 15.231,
  r: 15.231,
  transform: "translate(814.644 1394.738)",
  fill: "#e7f1f1",
  opacity: 0.631
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6015",
  cx: 15.231,
  cy: 15.231,
  r: 15.231,
  transform: "translate(900.951 1394.738)",
  fill: "#e7f1f1",
  opacity: 0.631
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357007",
  d: "M1256.03 1349.687h-144.738a6.579 6.579 0 110-13.158h144.738a6.579 6.579 0 010 13.158z",
  fill: "#f0f6f6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357008",
  d: "M1161.455 1321.726h-50.163a6.579 6.579 0 110-13.158h50.166a6.579 6.579 0 110 13.158z",
  fill: "#f0f6f6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357009",
  d: "M1270.539 1286.979h-260.7a14 14 0 00-13.981 13.981v57.563a14 14 0 0013.981 13.981h260.7a14 14 0 0013.98-13.981v-57.563a14 14 0 00-13.98-13.981zm12.336 71.544a12.351 12.351 0 01-12.336 12.336h-260.7a12.351 12.351 0 01-12.338-12.336v-57.563a12.351 12.351 0 0112.341-12.337h260.7a12.351 12.351 0 0112.336 12.336z",
  fill: "#eae9ef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357992",
  d: "M1282.874 1272.176a18.915 18.915 0 11-18.915 18.915 18.915 18.915 0 0118.915-18.915z",
  fill: "#513ea5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357010",
  d: "M1282.292 1301.728a.822.822 0 01-.241-.582v-20.934a.823.823 0 011.645 0v20.935a.822.822 0 01-1.4.582z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357011",
  d: "M1271.825 1291.262a.823.823 0 01.582-1.4h20.935a.823.823 0 010 1.645h-20.935a.82.82 0 01-.582-.245z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357040",
  d: "M1081.565 1527.269h-24.242v-170.986",
  fill: "none",
  stroke: "#eae9ef",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357506",
  d: "M1156.767 1575.924h119.788l30.472-86.163h-119.788z",
  fill: "#f0f6f6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 433",
  fill: "none",
  stroke: "#f0f6f6",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M1204.051 1572.448h-85.112"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6404",
  cx: 10.508,
  cy: 10.508,
  transform: "translate(1222.615 1522.336)",
  fill: "#513ea5",
  r: 10.508
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 19969",
  width: 170.925,
  height: 9.107,
  rx: 4,
  transform: "rotate(180 643.181 792.515)",
  fill: "#e0f0f0"
}));

function SvgMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 688.042 352.607",
    className: "w-full h-full"
  }, props), _ref);
}

export default SvgMain;